export const PERMISSIONS_ACTION = {
  USER_VIEW: "view_user",
  USER_ADD: "add_user",
  USER_CHANGE: "change_user",
  USER_DELETE: "delete_user",

  ROLE_VIEW: "view_group",
  ROLE_ADD: "add_group",
  ROLE_CHANGE: "change_group",
  ROLE_DELETE: "delete_group",

  CANDIDATE_VIEW: "view_candidate",
  CANDIDATE_ADD: "add_candidate",
  CANDIDATE_CHANGE: "change_candidate",
  CANDIDATE_DELETE: "delete_candidate",
  CANDIDATE_GENERATE_EXAM_LINK: "generate_exam_link",

  TOPIC_RULE_VIEW: "view_topicrule",
  TOPIC_RULE_ADD: "add_topicrule",
  TOPIC_RULE_CHANGE: "change_topicrule",
  TOPIC_RULE_DELETE: "delete_topicrule",

  INTERVIEW_QUESTION_VIEW: "view_interviewquestion",
  INTERVIEW_QUESTION_ADD: "add_interviewquestion",
  INTERVIEW_QUESTION_CHANGE: "change_interviewquestion",
  INTERVIEW_QUESTION_DELETE: "delete_interviewquestion",

  TOPIC_VIEW: "view_topic",
  TOPIC_ADD: "add_topic",
  TOPIC_CHANGE: "change_topic",
  TOPIC_DELETE: "delete_topic",
};

export const PERMISSIONS_MODEL = {
  USER: "user",
  ROLE: "group",
  CANDIDATE: "candidate",
  TOPIC_RULE: "topicrule",
  INTERVIEW_QUESTION: "interviewquestion",
  TOPIC: "topic",
};
